import React from "react"
import { Router, Route } from "react-router-dom"
import history from "client/history"
import {
	ROUTES,
} from "components/routes"

import AppBody from "components/app-body"

const App = () => (
	<Router history={history}>

		{ROUTES.length && ROUTES.map((route, key) => 
			<Route key={`route-${key}`} exact={route.exact || false} path={route.pathname} />
		)}

		<AppBody />

	</Router>
)

export default App;